import React from 'react';
import { FiCalendar } from 'react-icons/fi';

import { PassoExecutado } from '@/models/PassoExecutado';

import { FhirArtefatoType } from '@/features/enterprise/models/types';
import ListaAgendamentosDefault from './index.default';
import ListaAgendamentosFhir from './index.fhir';

import { ItemList, SectionTitle } from './styles';

interface ListaAgendamentosProps {
  agendamentos: FhirArtefatoType[];
  passoExecutado: PassoExecutado;
  integracaoEnterpriseAtiva?: boolean;
}

const ListaAgendamentos: React.FC<ListaAgendamentosProps> = ({
  agendamentos,
  passoExecutado,
  integracaoEnterpriseAtiva,
}) => {
  return (
    <ItemList>
      <SectionTitle>
        <FiCalendar size={20} />

        <h2>Agendamentos sugeridos</h2>
      </SectionTitle>

      {integracaoEnterpriseAtiva ? (
        <ListaAgendamentosFhir
          agendamentos={agendamentos}
          passo={passoExecutado}
        />
      ) : (
        <ListaAgendamentosDefault agendamentos={agendamentos} />
      )}
    </ItemList>
  );
};

export default ListaAgendamentos;
